module.exports = __webpack_public_path__ + "img/public/SiteIcons/editProfileIcon.svg?a0a723ae";